import styled from 'styled-components';

export const TabWrapper = styled.div`
  position: relative;
  max-width: 100%;
  height: 81px;

  div[role='tablist'] {
    padding-right: 130px;
  }
`;
TabWrapper.displayName = 'TabWrapper';

export const StatCategoryTabsShowAll = styled.div`
  position: absolute;
  top: 0.25rem;
  right: 0;
  z-index: 1;
  background-color: ${({ theme }) => theme.colours.canvas.secondary.weak};
`;
StatCategoryTabsShowAll.displayName = 'StatCategoryTabsShowAll';
